// OverlayersInitializer.tsx
import { useAtom } from "jotai";
import { useEffect } from "react";
import { addOrUpdateActiveOverlayerAtom, predefinedLEZsDerivedAtom } from "src/atoms/overlayers";

export function PredefinedLEZLayerInitializer() {
  const [predefinedLEZs] = useAtom(predefinedLEZsDerivedAtom);
  const [, addOrUpdate] = useAtom(addOrUpdateActiveOverlayerAtom);

  useEffect(() => {
    const firstLayer = predefinedLEZs[0];
    if (firstLayer) {
      addOrUpdate({ ...firstLayer, isActive: true });
    }
  }, [predefinedLEZs, addOrUpdate]);

  return null;
}
